import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/assets/pictos/z-0/magnifying-glass.png");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Breadcrumb/sk-Breadcrumb.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/@jobteaser/spark/dist/components/Button/sk-Button.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/circleci/project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FilterJobOffersLink"] */ "/home/circleci/project/src/features/jobRoles/components/Details/JobSearch/FilterJobOffersLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InteractiveJobSearch"] */ "/home/circleci/project/src/features/jobRoles/components/Details/JobSearch/InteractiveJobSearch.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/jobRoles/components/Details/JobSearch/ShowJobOffersLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResultCard"] */ "/home/circleci/project/src/modules/jobSearch/components/ResultCard/ResultCard.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/layouts/components/Layout/Layout.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/jobRoles/components/Details/PageContent.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/routing/components/LinkCard.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/jobRoles/components/Details/RelatedPages/RelatedPages.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppTrackingPageViewPropsUpdater"] */ "/home/circleci/project/src/modules/tracking/components/AppTrackingPageViewPropsUpdater.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackLink"] */ "/home/circleci/project/src/modules/tracking/components/TrackLink.tsx");
